<template>
  <div class="library">

    <div class="container mx-auto mb-10">
      <div class="flex">
        <div>
          <h2 class="text-xl mb-1">{{ library.name[lang] }}</h2>
          <p class="text-gray-500 mb-2" v-if="library.idSite" >Your custom library</p>
        </div>
        <div class="ml-10 flex-1">
          <button @click="remove" v-if="library.idSite" class="rounded-full bg-yellow-500 text-blue-50 shadow h-10 w-10 flex items-center justify-center text-xl">
            <font-awesome-icon icon="trash"></font-awesome-icon>
          </button>
        </div>
      </div>
      <div class="container mx-auto bg-white shadow rounded p-10 flex flex-col text-center text-gray-500">

        <div v-if="loading">
          <!-- Show placeholder when loading is pending -->
          <div v-for="(media, index) in library.mediacount" :key="index"></div>
        </div>
        <div v-else class="flex flex-wrap justify-center">
          <!-- Show medias when loading is finished -->
          <el-upload
            v-if="library.idSite"
            :http-request="addAttachment"
            :action="url"
            :show-file-list="false"
            style="margin: 6px;"
          >
            <el-button plain style="width: 80px; height:80px;">
              <font-awesome-icon icon="file-upload"></font-awesome-icon>
            </el-button>
          </el-upload>

          <media
            v-for="(media, i) in medias"
            :key="i"
            :id="media.id"
            :mediaid="media.id"
            :class="{'movable-media' : media.deletable === 1}"
            class="cursor-pointer"
            style="width: 80px; height:80px;margin: 6px;"
          ></media>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import media from '@/components/libraries/media.vue'
import draggable from 'vuedraggable'
import axios from 'axios'

export default {
  props: {
    id: {
      type: String,
      required: true
    }
  },
  components: { media, draggable },
  data () {
    return {
      loading: true,
      url: process.env.API + '/library/' + this.id + '/media/',
      dragging: false
    }
  },
  computed: {
    ...mapGetters('libraries', {
      getLibraryById: 'getById'
    }),
    ...mapGetters('medias', {
      mediasByLibrary: 'getByLibrary',
      getMediaById: 'getById',
      mediaMoving: 'mediaMoving'
    }),
    ...mapGetters('account', {
      site: 'currentSite',
      lang: 'defaultLang'
    }),

    library () {
      return this.getLibraryById(this.id)
    },

    medias () {
      return this.library ? this.mediasByLibrary({library: this.library}) : []
    },

    list: {
      get () {
        return this.medias
      },
      set (medias) {
        const moving = this._.cloneDeep(this.mediaMoving, false)

        const canMovetoThisLibrary = this.checkLibrary(moving.moveTo)
        if (moving.moveTo === this.library.id || !canMovetoThisLibrary) return

        medias.forEach((media) => {
          if (moving.id === media.id) {
            this.processMovedFile(moving.id, moving.moveTo)
          }
        })
      }
    }
  },
  watch: {
    site: function () {
      this.initMediasList()
    }
  },
  methods: {
    ...mapActions('medias', ['loadMedias', 'addMedia', 'startMove', 'removeMedia']),
    ...mapActions('libraries', ['removeLibrary']),

    initMediasList () {
      if (this.site) {
        this.loadMedias({id: this.id}).then(() => {
          this.loading = false
        })
      }
    },

    moving (e) {
      let media = this.getMediaById(e.dragged.id)
      media.moveTo = e.to.id
      const canMovetoThisLibrary = this.checkLibrary(media.moveTo)
      if (media.moveTo === this.library.id || !canMovetoThisLibrary) return false
      this.startMove(media)
    },

    checkLibrary (libraryId) {
      const targetLibraryMedias = this.mediasByLibrary({library: this.getLibraryById(libraryId)})
      return targetLibraryMedias.length ? targetLibraryMedias.some(media => media.deletable === 1) : true
    },

    complete (file, status, xhr) {
      var media = JSON.parse(xhr.responseText)
      this.addMedia({media: media, sitekey: this.site.sitekey})

      this.$notify({
        title: 'Success',
        message: this.$root.$t('notifications.library.mediaAdded'),
        type: 'success'
      })
    },
    addAttachment (uploader) {
      this.addMedia({libraryId: this.library.id, media: uploader.file})
    },
    remove () {
      this.removeLibrary({library: this.library})
        .then(() => {
          this.$notify({
            title: 'Success',
            message: this.$root.$t('notifications.library.deleted'),
            type: 'success'
          })
        }).catch(({response}) => {
          this.$notify.error({
            title: this.$root.$t('api.' + response.data.code + '.title'),
            message: this.$root.$t('api.' + response.data.error + '.message')
          })
        })
    },
    startMoving () {
      this.dragging = true
    },
    async processMovedFile (mediaId, libraryId) {
      let response = await axios.get(process.env.API + '/media/' + mediaId + '/', {responseType: 'blob'})
      let data = new Blob([response.data])
      let metadata = {
        type: 'image/png'
      }
      const media = new File([data], null, metadata)
      this.addMedia({ libraryId, media }).then(data => {
        let media = this.getMediaById(mediaId)
        this.removeMedia({media}).then(() => this.$root.$notify({title: 'Success', message: 'Media moved!', type: 'success'}))
      }).catch(err => {
        this.$root.$notify({
          title: 'Error',
          message: 'Unable to move media' + err.message,
          type: 'error'
        })
      })
    }
  },
  mounted () {
    this.initMediasList()
  }
}

</script>



// WEBPACK FOOTER //
// src/components/libraries/library.vue